module.exports = __webpack_public_path__ + "img/header-menu-button.e66af16e.svg";